export class BrandInstructionDto {
  brandInstructionType: string;
  brandInstructionText: string;
  id?: string;

  constructor(d?: BrandInstructionDto) {
    if (!d) {
      return;
    }

    this.brandInstructionType = d.brandInstructionType;
    this.brandInstructionText = d.brandInstructionText;
    this.id = d.id;
  }
}
